import { Container } from 'typedi';

import { ILogger, LoggerProvider } from '../logger';
import { IBetsUpdateData, ISportChannel, MessageBroker } from '@sparkware/uc-sdk-core';
import { IRouterData } from '../router/models';
import { RouterService } from '../router/router.service';
import { ViewInjector } from '../view-injector';
import { ViewSource } from '../../models/enums/Consts';
import { UserareaService } from '../external/userarea';
import { ISport } from './models/ISport';

export class Sport implements ISport {
    private readonly _logger: ILogger;

    private readonly _sportChannel: ISportChannel;

    private readonly _routerService: RouterService;
    private readonly _viewInjector: ViewInjector;
    private readonly _userareaService: UserareaService;
    private _betsUpdateExecuted = false;

    constructor() {
        this._logger = Container.get(LoggerProvider).getLogger('Sport');
        this._routerService = Container.get(RouterService);
        this._viewInjector = Container.get(ViewInjector);
        this._userareaService = Container.get(UserareaService);
        this._sportChannel = MessageBroker.getInstance().sport;
    }

    public onPreOpenBets = async () => {
        const sendData: IRouterData = { url: '/' };
        console.log(`ViewInjector: ${this._viewInjector.ActiveView}`);
        if (this._viewInjector.ActiveView === ViewSource.Content)
            await this._routerService.NavigateTo(sendData.url);

        this._sportChannel.topics.openMyBets.publish({ publisher: 'Sport' }, {});
    };

    public onBetsUpdate = (data: IBetsUpdateData) => {
        if (!this._betsUpdateExecuted) {
            const isLoadedUserarea = this._userareaService.findIfIsLoaded();
            if (!isLoadedUserarea)
                this._userareaService.executeOnload(() => {
                    this._sportChannel.topics.betsUpdate.publish({ publisher: 'Sport' }, data);
                });
            else
                this._logger.debug(
                    '[userareaSubscribeToBetsUpdate]Userarea is not loaded, republish after loading',
                );
            this._betsUpdateExecuted = true;
        }
    };
}
